import { ParticipantResponseDto } from '../dtos/participant/participant.response.dto';
import { ParticipantRequestDto } from '../dtos/participant/participant.request.dto';
import { Participant } from '@domain/participant/participant';
import { DispositifMapper } from './dispositif.mapper';

export class ParticipantMapper {
  static fromDto(dto: ParticipantResponseDto): Participant {
    return new Participant(
      dto.id,
      dto.firstName,
      dto.lastName,
      new Date(dto.birthDate),
      dto.active,
      (dto.dispositifs ?? []).map(d => DispositifMapper.fromSummaryDto(d)),
    );
  }

  static toRequestDto(entity: Participant): ParticipantRequestDto {
    return {
      firstName: entity.firstName,
      lastName: entity.lastName,
      birthDate: ParticipantMapper.formatAsLocalDate(entity.birthDate),
      active: entity.active,
      dispositifIds: entity.dispositifs.map(d => d.id as number),
    };
  }

  private static formatAsLocalDate(value: Date | string): string {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
